import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { Table, Spinner } from 'react-bootstrap';
import logo from '../jsx/components/Reports/food.jpeg';
import { useReactToPrint } from "react-to-print";

const EditRepairOrder = () => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      const location = useLocation();
const query = new URLSearchParams(location.search);

const repairOrderId = query.get("repairOrderId"); // 
    const [repairOrder, setRepairOrder] = useState([]);
    const [MainOrder, setMainOrder] = useState({});
    const [loading, setLoading] = useState(true);
     const [company, setcompany] = useState([]);
    useEffect(() => {
      const companydata = localStorage.getItem('companies');
      if (companydata) {
        const parsedData = JSON.parse(companydata);
        const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
        setcompany(singleCompany); // Set state to a single object
      }
    }, []);
       const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
    const userid = userData.id;
    const username = userData.name;
    const componentRef = useRef(null);
    const generatePDF = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Userdata",
       });
    const fetchRepairOrder = async () => {
        try {
            const response = await axios.get(`https://subk.education.com.ly/back/api/repairOrder/${repairOrderId}`);
            setRepairOrder(response.data.RepairOrder.repair_details || []);
            setMainOrder(response.data.RepairOrder || {});
            setLoading(false);
        } catch (error) {
            console.error('Error fetching repair order:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRepairOrder();
    }, []);

    const { customer, vehicle, TotalCost, RepairDate, Status, RestAmount } = MainOrder;

    if (loading) {
        return (
            <div className="text-center">
                <Spinner animation="border" />
                <p>جاري تحميل البيانات...</p>
            </div>
        );
    }
     
    return (
        <div className="container-fluid">
           <div className="row">
          <div className="col-lg-12">
            <div className="card mt-3">
             <div className="card-body" ref={componentRef} dir="rtl">
     <div className="row mb-4">
   <table className="table table-bordered "style={{ fontSize: "12px", lineHeight: "1" }} size="sm">
       <thead>
      <tr>
        <th colSpan="3" className="text-center bg-light">رقم الفاتورة: {MainOrder.InvoiceNumber}</th>
      </tr>
    </thead>
      
        </table>
        </div>
                           {/* <div className="row" >
                         <div className="col-xl-12 text-center row">
                         <div  style={{
           display: 'flex',
           justifyContent: 'space-between',
           alignItems: 'center',
           padding: '20px',
          }}>  <div 
         style={{
           fontSize: '24px',
           fontWeight: 'bold'
         }}>
                         <div className="d-flex"><h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold'}}>{company.CompanyName}</h2> </div>
                        <div className="d-flex"> <h2 style={{fontFamily: 'SC_AMEEN',color:'#003b53',fontWeight:'lighter'}}>{company.Description}</h2>  </div>
                        <div className="d-flex">                    <i class="fa-solid fa-location-dot pt-1 ps-2" style={{color:'#8e2927'}}></i>
                         <h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}> {company.Address}</h2> <i class="fa-solid fa-phone-flip p-1 px-2" style={{color:'#8e2927'}}></i><h5 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}>{company.ContactNumber}</h5></div>
     </div> 
     
      <img src={`https://subk.education.com.ly/back${company.ImageName}`} alt="Logo" style={{ height: "150px", width: "200px",  marginTop:'-20px' }} />
     
                          </div>
                       </div> 
                       </div>  */}
     {/* Car + Customer Details */}
     <div className="row mb-4">
       {/* Table 1: Vehicle Info */}
       <div className="col-md-6">
          <table className="table table-bordered "style={{ fontSize: "12px", lineHeight: "1" }} size="sm">
            <thead>
           <tr>
             <th colSpan="3" className="text-center bg-light">معلومات السيارة</th>
           </tr>
         </thead>
           <tbody>
              <tr>
               <td><strong>النوع:</strong> {vehicle?.make.MakeName || 'غير متوفر'}</td>
               <td><strong>الموديل:</strong> {vehicle?.vehicle_model.ModelName || 'غير متوفر'}</td>
                         <td><strong>السنة:</strong> {vehicle?.Year || 'غير متوفر'}</td>
     
             </tr>
             <tr>
               <td><strong>رقم اللوحة:</strong> {vehicle?.LicensePlate || 'غير متوفر'}</td>
             
               <td><strong>اللون:</strong> {vehicle?.Color || 'غير متوفر'}</td>
               <td><strong>رقم الهيكل:</strong> {vehicle?.ChassisNumber || 'غير متوفر'}</td>
             </tr>
             <tr>
               <td><strong>المحرك:</strong> {vehicle?.EngineNumber || 'غير متوفر'}</td>
               <td><strong>العداد:</strong> {MainOrder?.Km || 'غير متوفر'}</td>
               <td></td>
             </tr>
           </tbody>
         </table>
       </div>
     
       {/* Table 2: Customer Info */}
       <div className="col-md-6">
          <table className="table table-bordered table-sm" size="sm"style={{ fontSize: "12px", lineHeight: "1" }} >
           <thead>
           <tr>
             <th colSpan="2" className="text-center bg-light">معلومات الزبون</th>
           </tr>
         </thead>
           <tbody>
             <tr>
               <td><strong>الاسم:</strong> {customer?.FirstName || ''} {customer?.LastName || ''}</td>
               <td><strong>الهاتف:</strong> {customer?.Phone || 'غير متوفر'}</td>
             </tr>
            
           </tbody>
         </table>
       </div>
     </div>
     
     {/* Table 3: Parts & Services */}
     <div className="row">
       <div className="col-6">
         {/* Services Table */}
     {repairOrder.filter(item => item.service).length > 0 && (
       <Table bordered size="sm" style={{ fontSize: "12px", lineHeight: "1" }} >
         <thead>
           <tr>
             <th colSpan="3" className="text-center bg-light">الخدمات</th>
           </tr>
           <tr>
             <th>الخدمة</th>
             <th>الفني</th>
             <th>التكلفة</th>
           </tr>
         </thead>
         <tbody>
           {repairOrder.filter(item => item.service).map((item, index) => (
             <tr key={index}>
               <td>{item.service.ServiceName}</td>
               <td>{item.technician?.FirstName || "غير متوفر"}</td>
               <td>{item.ServiceCost || "-"}</td>
             </tr>
           ))}
            <tr>
             <td colSpan="2" className="text-end fw-bold">المجموع</td>
             <td className="fw-bold">
               {repairOrder
                 .filter(item => item.service)
                 .reduce((sum, item) => sum + (parseFloat(item.ServiceCost) || 0), 0)
               }
             </td>
           </tr>
         </tbody>
       </Table>
     )}
     
     {/* Parts Table */}
     
     
       </div>
        <div className="col-6">
        {repairOrder.filter(item => item.parts).length > 0 && (
       <Table bordered size="sm" style={{ fontSize: "12px", lineHeight: "1" }} >
         <thead>
           <tr>
             <th colSpan="4" className="text-center bg-light">قطع الغيار</th>
           </tr>
           <tr>
             <th>القطعة</th>
             <th>الكمية</th>
             <th>السعر للوحدة</th>
             <th>الإجمالي</th>
           </tr>
         </thead>
         <tbody>
           {repairOrder.filter(item => item.parts).map((item, index) => (
             <tr key={index}>
               <td>{item.parts.PartName}</td>
               <td>{item.PartQuantities || "-"}</td>
               <td>{item.PartCost || "-"}</td>
               <td>{item.PartQuantities && item.PartCost 
                      ? item.PartQuantities * item.PartCost 
                      : "-"}</td>
             </tr>
           ))}
              <tr>
             <td colSpan="3" className="text-end fw-bold">المجموع</td>
             <td className="fw-bold">
               {repairOrder
                 .filter(item => item.parts)
                 .reduce((sum, item) => sum + ((item.PartQuantities || 0) * (item.PartCost || 0)), 0)
               }
             </td>
           </tr>
         </tbody>
       </Table>
     )}
       </div>
     </div>
     <div className="mt-4">
          <Table bordered size="sm" style={{ fontSize: "12px", lineHeight: "1" }} >
                  <tbody>
                    <tr>
                      <td><strong>إجمالي الصيانة:</strong></td>
                      <td>
                        {repairOrder.reduce((sum, item) => {
                          const serviceCost = parseFloat(item.ServiceCost) || 0;
                          const partsCost = (parseFloat(item.PartQuantities) || 0) * (parseFloat(item.PartCost) || 0);
                          return sum + serviceCost + partsCost ;
                        }, 0)}
                      </td>
                    </tr>
                    <tr>
                      <td><strong>المدفوع مسبقاً:</strong></td>
                      <td>{MainOrder?.Prepay || 0}</td>
                    </tr>
                      <tr>
                      <td><strong>سعر الكشف:</strong></td>
                      <td>{MainOrder?.CheckPrice || 0}</td>
                    </tr>
                      <tr>
                      <td><strong> النخفيض:</strong></td>
                      <td>{MainOrder?.Discount || 0}</td>
                    </tr>
                    <tr>
                     
                      <td><strong>المتبقي:</strong></td>
                     <td>
         {
           (
             repairOrder.reduce((sum, item) => {
               const serviceCost = parseFloat(item.ServiceCost) || 0;
               const partsCost =
                 (parseFloat(item.PartQuantities) || 0) *
                 (parseFloat(item.PartCost) || 0);
       
               return sum + serviceCost + partsCost;
             }, 0)
             + (parseFloat(MainOrder?.CheckPrice) || 0)
             - (parseFloat(MainOrder?.Discount) || 0)
             - (parseFloat(MainOrder?.Prepay) || 0)
           ).toFixed(2)
         }
       </td>
       
                    </tr>
                    <tr>
                      <td colSpan="2"><strong>ملاحظات:</strong> {MainOrder?.Notes}</td>
                    </tr>
                  </tbody>
                </Table>
     </div>   </div>
                <div className="row">
     
                   <div className="col-xl-12  ">
     
     <div className=" px-5" style={{float :'right'}}>إعد بواسطة :  {username}</div>  <div className=" px-5" style={{float :'left'}}>    بتاريخ {formatDate(currentDate)}</div><center><p>الختم</p></center>
     
         </div> </div>   
              <div className="modal-footer">
                 <button  className="btn btn-primary m-2" onClick={generatePDF}>طباعه الفاتورة</button>
                             
         <Link to={`/OrdersList`} className="btn btn-primary">انهاء</Link>
     
               </div>
      
            </div></div></div></div>
    );
};

export default EditRepairOrder;
